import {combineReducers} from 'redux';
import adminAuthReducer from './adminAuth';


export default combineReducers({
    adminAuthReducer
})